<template>
    <div class="upGuideContainer">

        <div class="upGuideSection" id="unitsSetup">
            <div class="upGuideBlock">
                <h2>设置系统单位</h2>
                <ul>
                    <li>Customize -> Units Setup</li>
                    <li>将系统单位设置成毫米。</li>
                    <p>统一的系统单位，是为了资源模型比例一致。在其他系统单位设置下创建的资源模型，调用的时候会出现比例错误及位置漂移。</p>
                </ul>
                <video 
                    src="@/assets/video/up_unitsSetup.mp4" 
                    controls 
                    preload="none"
                    :poster="require('@/assets/video/up_unitsSetup_00000.jpg')">
                    您的浏览器不支持 HTML5 视频标签。
                </video>
            </div>
            <div class="upGuideBlock">
                <h2>核对模型尺寸</h2>
                <ul>
                    <li>创建参考物体。</li>
                    <li>检查资源模型尺寸是否正常。</li>
                    <p>为保证资源能正确被使用，请确保模型尺寸正确。如果尺寸不正常，请用缩放工具将模型缩放到正常尺寸。</p>
                </ul>
                <video 
                    src="@/assets/video/up_sizeCheck.mp4" 
                    controls
                    preload="none"
                    :poster="require('@/assets/video/up_sizeCheck_00117.jpg')">
                    您的浏览器不支持 HTML5 视频标签。
                </video>
            </div>
        </div>
        <div class="upGuideSection" id="mapSetup">
            <div class="upGuideBlock">
                <h2>设置贴图路径</h2>
                <ul>
                    <li>File -> Reference -> Asset Tracking Toggle (Shift + T)</li>
                    <li>将所有贴图路径设置为正确的文件夹。</li>
                    <p>丢失的贴图文件，在处理时将被丢弃，以该物体的线框颜色替代。请尽量找到资源模型的贴图文件，特别是重要的材质贴图。</p>
                </ul>
                <video 
                    src="@/assets/video/up_mpSetup.mp4" 
                    controls 
                    preload="none"
                    :poster="require('@/assets/video/up_mpSetup_00087.jpg')">
                    您的浏览器不支持 HTML5 视频标签。
                </video>
            </div>
        </div>
        <div class="upGuideSection" id="groupSetup">
            <div class="upGuideBlock">
                <h2>资源分组</h2>
                <ul>
                    <li>将要生成的资源模型单独成组。</li>
                    <li>一个组将生成一个资源文件，请根据使用习惯合理的成组。</li>
                    <li>单个资源结构不可分割，尽量不要将不太可能同步出现的物体一起成组。</li>
                    <p>有些资源可以携带配套物体，比如餐桌上的餐具、台子上的装饰品、衣柜内的衣服等；有些资源可能会成组出现，比如摆放好的沙发组合、摆放好的装饰品组合等；有些资源尽量不要作为一个资源成组、比如相同类型放在一起的临时收集组合等。请考虑每一个资源的使用场景，如果不会固定同时出现的模型，请不要生成一个单独的资源。</p>
                </ul>
                <video 
                    src="@/assets/video/up_groupSetup.mp4" 
                    controls
                    preload="none"
                    :poster="require('@/assets/video/up_groupSetup_00000.jpg')">
                    您的浏览器不支持 HTML5 视频标签。
                </video>
            </div>
        </div>
        <div class="upGuideSection" id="directionSetup">
            <div class="upGuideBlock">
                <h2>调整模型方向</h2>
                <ul>
                    <li>使用旋转工具调整场景中资源模型的方向。</li>
                    <li>所有资源模型的正面方向，都调整为顶视图朝下</li>
                    <p>统一确定资源模型的方向同样是为了资源能被正确的使用，错误的方向会造成在被使用时方向出现漂移。</p>
                </ul>
                <video 
                    src="@/assets/video/up_directiom.mp4" 
                    controls
                    preload="none"
                    :poster="require('@/assets/video/up_directiom_00000.jpg')">
                    您的浏览器不支持 HTML5 视频标签。
                </video>
            </div>
        </div>
        <div class="upGuideSection" id="collapse">
            <div class="upGuideBlock">
                <h2>资源塌陷</h2>
                <ul>
                    <li>KukuLib -> 塌陷整理, 或右键菜单 -> 塌陷整理。</li>
                    <li>程序将自动将每个组塌陷成一个单独的物体并整理材质和贴图。</li>
                    <li>物体放置方式选项会决定坐标远点的额位置，请正确选择每一个资源的放置方式。</li>
                    <p>放置方式决定物体的坐标原点，坐标原点决定物体被调用时的位置，错误的坐标原点会影响资源调用时的位置，也会影响缩略图渲染时的画面构图。只要正确的选择放置方式，多数时候程序会正确识别物体的坐标原点。但少部分不规则模型，比如枝叶会垂落到地面的植物、带拖线的落地灯等，会干扰坐标平面内容的识别。如有类似物体出现坐标原点错误，请手动调整物体的坐标原点再执行下一步。</p>
                    <p>这一步为不可逆操作，塌陷前请保存文件。点击"塌陷"，程序将自动处理所选资源。</p>
                </ul>
                <video 
                    src="@/assets/video/up_collapse.mp4"
                    controls
                    preload="none"
                    :poster="require('@/assets/video/up_collapse_00000.jpg')">
                    您的浏览器不支持 HTML5 视频标签。
                </video>
            </div>
        </div>
        <div class="upGuideSection" id="creatRes">
            <div class="upGuideBlock">
                <h2>创建资源</h2>
                <ul>
                    <li>KukuLib -> 创建库库, 或右键菜单 -> 创建库库</li>
                    <li>点击"创建"，程序将自动批量创建所选资源。</li>
                    <p>物体放置方式选项会决定坐标远点的额位置，请正确选择每一个资源的放置方式。准确的资源信息，将使资源在使用的时候更好的检索和查询。请认真填写准确的资源信息</p>

                </ul>
                <video 
                    src="@/assets/video/up_creat.mp4" 
                    controls 
                    preload="none"
                    :poster="require('@/assets/video/up_creat_00000.jpg')">
                    您的浏览器不支持 HTML5 视频标签。
                </video>
            </div>
        </div>
        <div class="upGuideSection" id="renderPreview">
            <div class="upGuideBlock">
                <h2>渲染缩略图</h2>
                <ul>
                    <li>KukuLib -> 渲染上传</li>
                    <li>任务列表显示所有的本地资源，隐藏已上传可显示未渲染上传的本地资源</li>
                    <li>点击"渲染缩略图"，程序会自动批量渲染所有未渲染资源的缩略图。</li>
                    <p>右键列表，可删除错误的资源文件。渲染可能需要比较长的时间，并且不可中断，请在完成手上的工作后，利用空闲时间执行渲染。</p>
                </ul>
                <video 
                    src="@/assets/video/up_render.mp4" 
                    controls 
                    preload="none"
                    :poster="require('@/assets/video/up_render_00000.jpg')">
                    您的浏览器不支持 HTML5 视频标签。
                </video>
            </div>
        </div>
        <div class="upGuideSection" id="uploadRes">
            <div class="upGuideBlock">
                <h2>上传资源</h2>
                <ul>
                    <li>KukuLib -> 渲染上传</li>
                    <li>任务列表显示所有的本地资源，隐藏已上传可显示未渲染上传的本地资源</li>
                    <li>点击"上传资源"，程序会自动批量上传未上传资源。</li>
                    <p>右键列表，可删除错误的资源文件。上传可能需要较长时间，请在完成手上的工作后，利用空闲时间执行上传。</p>
                </ul>
                <video 
                    src="@/assets/video/up_upload.mp4" 
                    controls 
                    preload="none"
                    :poster="require('@/assets/video/up_upload_00000.jpg')">
                    您的浏览器不支持 HTML5 视频标签。
                </video>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    name: 'UpGuide' 
}

</script>

<style>

.upGuideContainer{
    width: 100%;
    margin: 0 auto;
}

.upGuideSection{
    max-width: 1024px;
    margin: 0 auto;
    border-radius: 12px;
    background-color: rgb(250, 250, 250);
    padding: 48px;
    display: flex;
    flex-direction: column;
}

.upGuideBlock{
    flex-direction: column;
    display: flex;
}

.upGuideSection h2{
    font-size: 20px;
    padding-bottom: 14px;
}

.upGuideSection p{
    color: rgb(180, 180, 180);
    padding-left: 14px;
    padding-bottom: 14px;
}

.upGuideSection li{
    color: gray;
    margin-left: 16px;
    list-style-type: decimal;
    line-height: 24px;
}

.upGuideBlock video{
    margin-top: 14px;
    margin-bottom: 48px;
    width: 720px;
    height: 405px;
    border-radius: 12px;
}

</style>